import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH, RJSC_PAGE_LINK } from "../../../app/constants";
import { Button, Header, Paragraph, ErrorMark } from "../../../components/RegularComponents";
import { ERROR_STRING } from "../../../app/errors";

export const ChooseNewComplianceOfficier = (props) => {
  const dispatch = useDispatch();

  const [route, setRoute] = useState("");
  const [validationError, setValidationError] = useState(false);

  //const [applicationSaveError, setApplicationSaveError] = useState(false);

  const handleContinue = () => {

    if(!route){
        setValidationError(true);
        return;
    }


    if(route === "backToStart"){
        dispatch(push(`${ROUTE_PATH.MA_APP}${ROUTE_PATH.MA_PRIVACY_NOTICE}`));
    }

    if(route === "updateRJSC"){
      window.open(RJSC_PAGE_LINK, '_blank');
    }
  };

  return (
    <div className="container">
      {/* Title */}

      <div className="row">
        <div className="col-lg-8">
          <Header
            id="choose-new-compliance-officer-header"
            header={"Choose a new compliance officer"}
          />
          <Paragraph
            id="choose-new-compliance-officer-text"
            text={[
              'Choose a compliance officer at your company making sure that they are a partner, director, officer, or sole proprietor with the <a style="text-decoration: underline" href="https://rjsc.novascotia.ca/" target="_blank">Registry of Joint Stock Companies</a> RJSC. The compliance officer is the only person who can apply for a Mortgage Administrator licence',  
            ]}
          />
        </div>
      </div>


      <div className={"row"}>
        <div className={"col-9"}>
          <fieldset className="ns-fieldset">
            <div className={"ns-radios ns-radios--large"}>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={"backToStart"}
                  onChange={(e) => {
                      setRoute(e.target.value);
                      setValidationError(false);
                  }}
                  checked={route === "backToStart"}
                  id={"choose-new-compliance-officer-backToStart-input"}
                  name={"choose-new-compliance-officer-backToStart-input"}
                />
                <label
                  id={"choose-new-compliance-officer-backToStart-label"}
                  className="ns-radios__label"
                  htmlFor={"choose-new-compliance-officer-backToStart-input"}
                >
                  <span className="ns-label-span">
                    Go back to start page
                  </span>
                </label>
              </div>
              <div className="ns-radios__item">
                <input
                  className="ns-radios__input"
                  type={"radio"}
                  value={"updateRJSC"}
                  onChange={(e) => {
                      setRoute(e.target.value);
                      setValidationError(false);
                  }}
                  checked={route === "updateRJSC"}
                  id={"choose-new-compliance-officer-updateRJSC-input"}
                  name={"choose-new-compliance-officer-updateRJSC-input"}
                />
                <label
                  id={"choose-new-compliance-officer-updateRJSC-label"}
                  className="ns-radios__label"
                  htmlFor={"choose-new-compliance-officer-updateRJSC-input"}
                >
                  <span className="ns-label-span">
                    Update company information in RJSC
                  </span>
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      {/* Continue */}
      <div className="row">
      <div className={"col-lg-4" + (validationError ? " has-error" : "")}>
          <Button
            className="ns-btn-yes-no"
            buttonType="regular_primary"
            onClick={handleContinue}
            text="Continue"
          />
          {validationError && ErrorMark()}
          {validationError && (
            <div className="ns-error-message">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.CHECK_FIELDS}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
